import { HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { LiveUpdateService } from './live-update.service';

export function liveUpdateInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // this needs to be here otherwise we get an injection error
  const liveUpdateService: LiveUpdateService = inject(LiveUpdateService);

  return next(req).pipe(
    tap(event => {
      if (event.type !== HttpEventType.Response) {
        return;
      }

      const version: string | null = event.headers.get('Cep-Version');

      if (version) {
        void liveUpdateService.checkForAndApplyUpdate(version);
      }
    }),
  );
}
